import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <section className="footer">
      <section className="footer__ref">
        Contact Information:{" "}
        <article className="left">
          Email:{" "}
          <a
            style={{ color: "#6ea4fa" }}
            href="mailto:karimdarrag_pc@outlook.com"
          >
            karimdarrag_pc@outlook.com
          </a>
          <article>Phone Number: (416) 879-2192</article>
        </article>
      </section>
      <article className="responsive__contact">
        My Contact Information: <br></br>Email: karimdarrag_pc@outlook.com{" "}
        <br></br>Phone Number: (416) 879-2192
      </article>
      <section className="footer__ref__middle">
        <article className="contact__form">
          <article className="contact__title">
            Send me a message directly!
          </article>
          <form
            action="https://formsubmit.co/afe6e1835e22896ff2218f859ea2c15e"
            method="POST"
          >
            <center>Your Name:</center>
            <input type="text" name="name" required />
            <center>Your Email:</center>
            <input type="email" name="email" required />
            <center>The Subject:</center>
            <input type="text" name="subject" required />
            <center>Your Message:</center>
            <textarea name="message" required /> <br></br>
            <button className="contact__button" type="submit">
              Send Message!
            </button>
          </form>
        </article>
      </section>
      <section className="footer__ref">
        <article className="right">
          This website was designed and developed by Karim Darrag using
          React.js.
        </article>
      </section>
    </section>
  );
};

export default Footer;
